import React, { Fragment } from 'react';
import DesignStatus from '../../../../common/components/DesignStatus/DesignStatus';
import { ProjectApi } from '../../api/project-api';
import { clone } from '../../../../common/common';
import Navbar from '../components/Navbar';
import CustomerDesignForm from '../components/CustomerDesign/Form';

import {
  RoomPlanRecomendations,
  RoomPhotosRecomendations,
  showRoomPhotoHint,
  hideRoomPhotoHint,
  showRoomPlanHint,
  hideRoomPlanHint,
  ProjectSubmittedModal,
  showProjectSubmittedModal,
  hideProjectSubmittedModal,
} from '../untils/pop-up-helpers';
import {
  isProjectCompletedForCustomer,
  isProjectCategoryReleasedForCustomer,
  isProjectInProgressForCustomer,
  isConsultancy,
} from '../utils/projectStatusForCustomer';
import {isOnboarding} from "../../../../common/components/ProjectStatus/utils";

class BriefView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project,
      proPlatformAccount: props.proPlatformAccount,
      questions: props.questions,
      roomsInfo: props.rooms,
      customer: props.customer,
    };
    this.sendToDesigner = this.sendToDesigner.bind(this);
  }

  sendToDesigner(projectId) {
    const self = this;
    ProjectApi.updateState(
      projectId,
      response => {
        self.setState({ project: response.project, nextProject: response.next_project });
      },
      () => {
        const project = clone(self.state.project);
        project.error = true;
        self.setState({ project });
      },
    );
  }

  isApproved() {
    const { project } = this.state;
    return isProjectCompletedForCustomer(project);
  }

  isCategoryReleased() {
    const { project } = this.state;
    return isProjectCategoryReleasedForCustomer(project);
  }

  render() {
    const { project, proPlatformAccount, questions, roomsInfo, customer, nextProject } = this.state;
    const onboarding = isOnboarding(project.status);
    const isDisabled = proPlatformAccount
      ? project.status_for_customer !== 'onboarding'
      : ['in_progress', 'complete', 'awaiting'].includes(project.status_for_customer);
    const projectApproved = this.isApproved();
    const categoryRelease = this.isCategoryReleased();

    const inProgress = isProjectInProgressForCustomer(project);
    // const completed = isProjectCompletedForCustomer(project);
    // return completed || (categoryRelease && inProgress);
    const consultancy = isConsultancy(project);
    const showNavBar = projectApproved || categoryRelease;
    return (
      <Fragment>
        {onboarding ? null : (
          <div className="container">
            <DesignStatus
              project={project}
              editable={false}
              consultancy={consultancy}
              customer={customer}
              customerView
            />
          </div>
        )}
        <div className="container">
          {showNavBar && (
            <Navbar
              project={project}
              categoryRelease={categoryRelease && inProgress}
              consultancy={consultancy}
              proPlatformAccount={proPlatformAccount}
            />
          )}
        </div>
        <div className="container">
          <CustomerDesignForm
            key={project.id}
            project={project}
            proPlatformAccount={proPlatformAccount}
            questions={questions}
            roomsInfo={roomsInfo}
            sendToDesigner={this.sendToDesigner}
            showRoomPhotoHint={showRoomPhotoHint}
            showRoomPlanHint={showRoomPlanHint}
            showProjectSubmittedModal={showProjectSubmittedModal}
            disabled={isDisabled}
          />

          <RoomPhotosRecomendations hideHint={hideRoomPhotoHint} />
          <RoomPlanRecomendations hideHint={hideRoomPlanHint} />
          <ProjectSubmittedModal
            proPlatform={proPlatformAccount}
            consultancy={consultancy}
            onClose={hideProjectSubmittedModal}
            nextProject={nextProject}
          />
        </div>
      </Fragment>
    );
  }
}

export default BriefView;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/screens/BriefView.js